import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=c4b91e9c&scoped=true&"
import script from "./Vessel.vue?vue&type=script&lang=js&"
export * from "./Vessel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b91e9c",
  null
  
)

export default component.exports